const Header = () => {
  return (
    <div className="header">
      <h1>Hangman</h1>
      <div>Find the hidden word - Enter a letter</div>
    </div>
  );
};

export default Header;
